import React, { Fragment } from 'react';
import Typo from 'components/shared/Typo';
import RebootConfirmDialog from './RebootConfirmDialog';

function RebootGA1DeviceDialog(props) {
  return (
    <RebootConfirmDialog
      title={
        <Typo as="h3" variant="heading5">
          Reboot the device?
        </Typo>
      }
      description={
        <Fragment>
          <Typo paragraph variant="body1" color="error">
            Please note:
          </Typo>
          <Typo paragraph variant="body2" color="error">
            Reboot applies only to the Active Partition of the device and does not change the SW version. During Reboot,
            no other user actions are allowed.
          </Typo>
          <Typo paragraph variant="body2">
            Prior to Rebooting any GA1 device, you will need to review and update the settings for WiFi Enabled/Disabled
            specifically EnableTimer and DisableTimer in the event of a non-recoverable GA1 Reboot failure.
          </Typo>
          <Typo paragraph variant="body2">
            A Reboot Timeout of 5 minutes is set as default if the Reboot is unsuccessful.
          </Typo>
        </Fragment>
      }
      {...props}
    />
  );
}

export default RebootGA1DeviceDialog;
